import React from "react";
import Button from '@mui/material/Button';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import useAddWardHook from "./adWardHook";

const initialState = {
    activeStatus: false,
    wardCode: "",
    wardName: "",
    description: "",
}
const AddWard = () => {
    const {
        roomTypeState,
        handleInputChange,
        handleWardSubmit,
        handleGoBack
    } = useAddWardHook(initialState)
    return (
        <>

            <form>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Ward</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Ward Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><AccountBalanceIcon /></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Ward Code" name="wardCode"
                                        value={roomTypeState?.wardCode}
                                        onChange={handleInputChange} required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Ward Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control"
                                        placeholder="Ward Name" name='wardName'
                                        value={roomTypeState?.wardName}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Active Status*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <select
                                        className={"form-control"}
                                        selected={roomTypeState?.activeStatus}
                                        value={roomTypeState?.activeStatus}
                                        onChange={handleInputChange}
                                        required
                                        name="activeStatus"
                                    >
                                        <option></option>
                                        <option value={true}>Yes</option>
                                        <option value={false}>No</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <textarea
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control"
                                        placeholder="Description" name='description'
                                        value={roomTypeState?.description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => {
                            handleWardSubmit(event)
                        }}
                    >Add Rooms</Button>
                </div>
            </form>
        </>
    )
};

export default AddWard;